export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/watermark.worker.5b9252e2.worker.js");
}
